module.exports = __webpack_public_path__ + "img/Color 001.70b63380.jpg";